import { Navigate } from "react-router-dom";
import { useDevopstrioAuth } from "../context/DevopstrioAuthContext";

export default function DevopstrioProtectedRoute({ children }) {
  const { devopstrioUser } = useDevopstrioAuth();

  if (!devopstrioUser?.token) {
    return <Navigate to="/devopstriologin" replace />;
  }

  return children;
}
